import React from "react";
import Auth from "../context/Auth";
import { DriversProvider } from "./Houses";
import { UsersProvider } from "./User";
const MainContextProvider = ({ children }) => {
  return (
    <Auth>
      <DriversProvider>
        <UsersProvider>{children}</UsersProvider>
      </DriversProvider>
    </Auth>
  );
};

export default MainContextProvider;
